if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
               if (this.dataset.libeauColorFilter === 'true') {
          this.libeauUnsubscribe = subscribe(
            PUB_SUB_EVENTS.variantChange,
            ({ data }) => {
              const productInfo = this.closest('product-info');
              if (!productInfo) return;

              const sectionId =
                productInfo.dataset.originalSection ||
                productInfo.dataset.section;

              if (data.sectionId !== sectionId) return;

              this.libeauFilterColor(data.variant?.featured_media?.id);
            }
          );
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      libeauFilterColor(featuredMediaId) {
        if (this.dataset.libeauColorFilter !== 'true') return;

                const bordeauxIds = [
          '60399440757065',
          '60401207869769',
        ];

        const blackIds = [
          '58947285516617',
          '58947285549385',
          '58947285582153',
          '58947285614921',
          '58947296657737',
        ];

        const selectedId = String(featuredMediaId || '');
        const isBordeaux = bordeauxIds.includes(selectedId);

        if (!isBordeaux && !blackIds.includes(selectedId)) return;

        const visibleIds = new Set(
          isBordeaux ? bordeauxIds : blackIds
        );
        const knownIds = new Set([...blackIds, ...bordeauxIds]);

        const filterItems = (items, attribute) => {
          items.forEach((item) => {
            const value = item.getAttribute(attribute) || '';
            const mediaId = value.split('-').pop();
            if (!knownIds.has(mediaId)) return;

            if (visibleIds.has(mediaId)) {
              item.style.removeProperty('display');
              item.removeAttribute('aria-hidden');
            } else {
              item.style.setProperty('display', 'none', 'important');
              item.setAttribute('aria-hidden', 'true');
            }
          });
        };

        filterItems(
          this.elements.viewer.querySelectorAll('li[data-media-id]'),
          'data-media-id'
        );

        if (this.elements.thumbnails) {
          filterItems(
            this.elements.thumbnails.querySelectorAll('li[data-target]'),
            'data-target'
          );
        }

        const productInfo = this.closest('product-info');
        const sectionId = productInfo?.dataset.section;
        const modal = sectionId
          ? document.getElementById(`ProductModal-${sectionId}`)
          : null;

        if (modal) {
          filterItems(
            modal.querySelectorAll('[data-media-id]'),
            'data-media-id'
          );
        }

        this.elements.viewer.resetPages?.();
        this.elements.thumbnails?.resetPages?.();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
